import { POLAND_NAME } from '@ads/front-core/constants/countries'
import { TDictionary } from '@ads/front-core/interfaces'

export const getPolandIdFromDictionary = (dictionary?: TDictionary[]) =>
  Number(dictionary?.find(c => c.value === POLAND_NAME)?.id)
